<template lang="pug">
	div.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
				.card
					.card-header.bg-info.text-white
						span.fa.fa-search.mr-2
						| Búsqueda de bloques
					.card-body
						.form-group
							label Emisora
							select.form-control(v-model="filtro.emisora", @change="buscar")
								option(:value="null") Selecciona
								option(v-for="emisora in listadoEmisoras", :key="emisora.ID_emisora", :value="emisora.ID_emisora") {{emisora.nombre}}
						.form-group
							label Día
							datepicker(
								v-model="filtro.dia"
								:bootstrap-styling="true"
								:language="$dateLang"
								:monday-first="true"
								:inline="true"
								@input="buscar()"
							)
					.card-footer
						button.btn.btn-warning.m-1(@click="nuevoBloque")
							span.fa.fa-gear.mr-2
							| Generar
						button.btn.btn-danger.m-1(@click="nuevoBloque")
							span.fa.fa-trash.mr-2
							| Eliminar
						button.btn.btn-primary(@click="clonar", v-if="filtro.emisora && filtro.dia")
							span.fa.fa-sitemap.mr-2
							| Clonar

			.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
				.card
					.card-header
						span.fa.fa-list.mr-2
						| Resultados
					div.table-responsive
						table.table.table-striped.m-0
							thead.bg-dark.text-white
								tr
									th Emisora
									th Día
									th Horas
									th Duración
									th Nombre
									th Programa
									th
							tbody
								tr(v-for="bloque in listadoBloques", :key="bloque.ID_bloque")
									td.p-0.pl-1(style="vertical-align:middle;") {{bloque.emisoraNombre}}
									td.p-0(style="vertical-align:middle;")
										span {{bloque.diaUnix | moment('DD-MM-YYYY')}}
									td.p-0(style="vertical-align:middle;")
										span {{bloque.hora_inicio}}
										br
										span {{bloque.hora_fin}}
									td.p-0(style="vertical-align:middle;")
										span {{bloque.duracion}}
									td.p-0(style="vertical-align:middle;") {{bloque.nombre}}
									td.p-0(style="vertical-align:middle;") {{bloque.programaNombre}}
									td.p-0.text-right.pr-1(style="vertical-align:middle;")
										button.mr-1.btn.btn-primary(@click="editar(bloque)")
											span.fa.fa-edit
										button.btn.btn-danger(@click="eliminar(bloque)")
											span.fa.fa-trash
					.card-body.text-center.p-4(v-if="listadoBloques.length === 0")
						h4.text-danger
							span.fa.fa-info-circle(style="font-size:2em;")
							br
							| No hay bloques con este criterio
		generador-bloques(v-if="generarBloques", @cerrar="generarBloques = null", :plantilla="plantillaDia")
		editor-bloque(v-if="editarBloque", :bloque="editarBloque", @cerrar="editarBloque = null", @guardado="buscar")
</template>

<script>
import GeneradorBloques from './generador-bloques.vue'
import BtnDias from '../utilidades/select-dias.vue'
import EditorBloque from './editor-bloque.vue'
import axios from 'axios'
export default {
	components: {
		'generador-bloques': GeneradorBloques,
		'btn-dias': BtnDias,
		'editor-bloque': EditorBloque
	},
	data () {
		return {
			filtro: {
				emisora: null,
				dia: new Date()
			},
			ID_bloque: null,
			listadoEmisoras: [],
			listadoBloques: [],
			editarBloque: null,
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			plantillaDia: null,
			generarBloques: null
		}
	},
	created () {
		this.getListadoEmisoras()
	},
	methods: {
		buscar () {
			const buscar = JSON.parse(JSON.stringify(this.filtro))
			buscar.dia = Math.floor(new Date(this.filtro.dia.getTime()).getTime() / 1000)
			axios.post('gestion-emisoras/php/api/bloques/buscar-bloques.php', buscar)
				.then(res => {
					this.listadoBloques = res.data.listado
				})
				.catch(this.$responseError)
		},
		getDias (misDias) {
			const str = []
			for (let i = 0; i < misDias.length; i++) {
				str.push(this.dias[misDias[i]])
			}
			return str.join(', ')
		},
		getListadoEmisoras () {
			axios.post('/gestion-emisoras/php/api/emisoras/buscar-emisoras.php', {activa: true})
				.then(res => {
					this.listadoEmisoras = res.data.listado
				})
				.catch(this.$responseError)
		},
		nuevoBloque () {
			this.plantillaDia = null
			this.generarBloques = true
		},
		editar (bloque) {
			this.editarBloque = bloque
		},
		eliminar (bloque) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar bloque',
				mensaje: `¿Quieres eliminar este bloque?
				Si hay publicidad insertada, quedará desasignada`,
				callback: acepta => {
					if (acepta) {
						this.$http.delete('gestion-emisoras/php/api/bloques/del-bloque.php?ID_bloque=' + bloque.ID_bloque)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Eliminado',
									mensaje: 'Se ha eliminado el bloque correctamente'
								})
								this.buscar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		clonar () {
			const buscar = JSON.parse(JSON.stringify(this.filtro))
			buscar.dia = Math.floor(new Date(this.filtro.dia.getTime()).getTime() / 1000)
			axios.post('gestion-emisoras/php/api/bloques/buscar-bloques.php', buscar)
				.then(res => {
					// Armamos el objeto
					this.plantillaDia = {
						ID_bloque: null,
						emisora_ID: this.filtro.emisora,
						hora_inicio: null,
						hora_fin: null,
						programa_ID: null,
						activo: true,
						dias: [],
						horas: []
					}

					for (let i = 0; i < res.data.listado.length; i++) {
						this.plantillaDia.horas.push({
							hora_inicio: res.data.listado[i].hora_inicio,
							hora_fin: res.data.listado[i].hora_fin,
							id: res.data.listado[i].ID_bloque
						})
					}

					this.generarBloques = true
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/bloques/bloques.vue